module.exports = __webpack_public_path__ + "static/media/Informe CVC.3d1a67c2.jpg";